import {
  getEmbedType
} from './index';
import Editor from '../Editor';

export const isYouTube = value => getEmbedType(value) === Editor.EMBED.YOUTUBE;
export const isTwitter = value => getEmbedType(value) === Editor.EMBED.TWITTER;
export const isFacebook = value => getEmbedType(value) === Editor.EMBED.FACEBOOK;
export const isInstagram = value => getEmbedType(value) === Editor.EMBED.INSTAGRAM;
export const isCode = value => getEmbedType(value) === Editor.EMBED.CODE;